import React from 'react';
import classNames from 'classnames';

const Badge = ({ dark, className, children, onClick, larger, rounded }) => (
  <span
    onClick={onClick}
    onKeyDown={e => {
      if (e.key === 'Enter') {
        onClick();
      }
    }}
    className={classNames(
      'Badge',
      dark && 'Badge--dark',
      larger && 'Badge--larger',
      rounded && 'Badge--rounded',
      className,
    )}
    role="button"
    tabIndex="0"
  >
    {children}
  </span>
);

export default Badge;
